import { createFileRoute } from '@tanstack/react-router';

import { CoursesView } from '@/views/courses-view.tsx';
import { useAuth } from '@/store/auth.ts';

export const Route = createFileRoute('/_learner/courses')({
  component: CoursesPage,
});

function CoursesPage() {
  // The _learner gate guarantees a non-admin user; null is only a transient
  // post-logout state, so render nothing rather than crash.
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <CoursesView user={user} />;
}
